/* Copyright (c)2023 Sky Co., LTD. All rights reserved. */
import * as schema from '@/models/Mobile/Android/AndroidManagementV1Schema'

/// <summary>
/// アプリ管理のアプリ設定
/// </summary>
export class AndroidAppMgrApplicationSetting {
    /// <summary>
    /// 基本情報
    /// </summary>
    basicInfo = new AndroidAppMgrApplicationBasicJsonExtend();

    /// <summary>
    /// Json形式のポリシー
    /// </summary>
    policyJson = new schema.AMAPI_ApplicationPolicyExtend();
}

/// <summary>
/// アプリ管理のアプリ情報(基本情報) ※Policyに入らないデータ
/// ※※※オンプレ版とのインターフェースにも使われているので変更しないでください。
/// ※※※M1ではWebコントローラーとのインターフェースにも使われているので変更しないでください。
/// </summary>
export class AndroidAppMgrApplicationBasicJson {
    /// <summary>
    /// パッケージ名
    /// </summary>
    packageName = "";

    /// <summary>
    /// アイコン
    /// </summary>
    iconUrl = "";

    /// <summary>
    /// アプリケーション名
    /// </summary>
    appName = "";

    /// <summary>
    /// カテゴリ
    /// </summary>
    category = "";

    /// <summary>
    /// 提供元
    /// </summary>
    author = "";

    /// <summary>
    /// 更新日時(UTC)
    /// </summary>
    updateTimeUtc?: Date = undefined;

}
export class AndroidAppMgrApplicationBasicJsonExtend extends AndroidAppMgrApplicationBasicJson{
    /// <summary>
    /// アプリケーション種別
    /// </summary>
    appSettingType = 0;
}

/// <summary>
/// アプリ管理のアプリ情報(SKYSEAアプリ情報) ※Policyに入らないデータ
/// ※※※オンプレ版とのインターフェースにも使われているので変更しないでください。
/// ※※※M1ではWebコントローラーとのインターフェースにも使われているので変更しないでください。
/// </summary>
export class AndroidAppMgrSKYSEAApplicationJson {
    /// <summary>
    /// MDMアプリ情報
    /// </summary>
    mdmAppInfo = new MDMAppInfo();
}

/// <summary>
/// アプリ管理のアプリ情報(MDMアプリ情報) ※Policyに入らないデータ
/// ※※※オンプレ版とのインターフェースにも使われているので変更しないでください。
/// ※※※M1ではWebコントローラーとのインターフェースにも使われているので変更しないでください。
/// </summary>
export class MDMAppInfo {
    /// <summary>
    /// パッケージ名
    /// </summary>
    packageName = "";
}



/* Copyright (c)2023 Sky Co., LTD. All rights reserved. */
